const defStyles = [
    'color: white',
    'padding: 4px 8px',
    'border-radius: 5px',
];

function printLog(type, msg, styles) {
    console.log(
        `%cFogo.${type}%c ${msg}`,
        defStyles.concat(styles).join(';'),
        '',
    );
}

export default {
    error(msg) {
        printLog('ERROR', msg, ['background-color: #cc3300']);
    },
    warn(msg) {
        printLog('WARN', msg, ['background-color: #dda72e']);
    },
    debug(msg) {
        printLog('DEBUG', msg, ['background-color: #3c8fd7']);
    },
    info(msg) {
        printLog('INFO', msg, ['background-color: #57a957']);
    },
};
